(function (window, document) {
  'use strict';

  if (window.LynxtourAttribution) return;

  var PREVIEW_CONTEXT_CONFIRMED = false;
  var STORAGE_NAMESPACE = null;
  var initialFirstTouch = null;
  var ENVELOPE_KEY = 'lynxtour_first_touch_v1';
  var INQUIRY_ID_KEY = 'lynxtour_inquiry_id_v1';
  var WHATSAPP_REFERENCE_KEY = 'lynxtour_whatsapp_reference_v1';
  var WHATSAPP_REGISTRY_PENDING_KEY = 'lynxtour_whatsapp_registry_pending_v1';
  var WHATSAPP_REGISTRY_REGISTERED_KEY = 'lynxtour_whatsapp_registry_registered_v1';
  var WHATSAPP_REFERENCE_PREFIX = 'LX-';
  var WHATSAPP_REGISTRY_CONTRACT = 'lynxtour.whatsapp-attribution.v1';
  var DEFAULT_REGISTRY_TIMEOUT_MS = 1200;
  var MAX_REGISTRY_TIMEOUT_MS = 3000;
  var WHATSAPP_REGISTRY_ENDPOINT = 'https://api-dev.sunrisevacation.cn/v1/whatsapp/register';
  var registryRequests = {};
  var retriedPendingReference = '';
  var registryPendingMemory = null;
  var registryRegisteredMemory = '';
  var identityMemory = {};
  var whatsappNavigation = null;
  var WHATSAPP_HANDOFF_RECOVERY_MS = 1500;
  if (typeof window.LynxtourWhatsAppRegistryConfig === 'undefined') {
    window.LynxtourWhatsAppRegistryConfig = Object.freeze({
      enabled: true,
      endpoint: WHATSAPP_REGISTRY_ENDPOINT,
      timeoutMs: DEFAULT_REGISTRY_TIMEOUT_MS
    });
  }
  var MAX_URL_LENGTH = 1000;
  var MAX_PARAMETER_LENGTH = 500;
  var PARAMETER_NAMES = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'wbraid',
    'gbraid'
  ];
  var ID_PATTERN = /^wi-[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  function storageGet(key) {
    var namespace = resolveStorageNamespace();
    if (namespace === null) return '';
    try {
      return window.sessionStorage.getItem(namespace + key) || '';
    } catch (error) {
      return '';
    }
  }

  function storageSet(key, value) {
    var namespace = resolveStorageNamespace();
    if (namespace === null) return false;
    try {
      window.sessionStorage.setItem(namespace + key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function identityGet(key) {
    if (resolveStorageNamespace() === null) return '';
    if (Object.prototype.hasOwnProperty.call(identityMemory, key)) {
      var value = identityMemory[key];
      if (storageGet(key) !== value) storageSet(key, value);
      return value;
    }
    return storageGet(key);
  }

  function identitySet(key, value) {
    if (resolveStorageNamespace() === null) return;
    identityMemory[key] = value;
    storageSet(key, value);
  }

  function cleanUrl(value) {
    try {
      var parsed = new URL(value, window.location.origin);
      if (!/^https?:$/.test(parsed.protocol)) return '';
      return (parsed.origin + parsed.pathname).slice(0, MAX_URL_LENGTH);
    } catch (error) {
      return '';
    }
  }

  function isLynxtourHost(value) {
    var hostname = String(value || '').toLowerCase();
    return hostname === 'lynxtour.cn' || hostname === 'www.lynxtour.cn';
  }

  function externalReferrer(value) {
    if (!value) return '';
    try {
      var parsed = new URL(value, window.location.origin);
      if (!/^https?:$/.test(parsed.protocol)) return '';
      var referrerHost = parsed.hostname.toLowerCase();
      var currentHost = window.location.hostname.toLowerCase();
      if (referrerHost === currentHost) return '';
      if (isLynxtourHost(referrerHost) && isLynxtourHost(currentHost)) return '';
      return (parsed.origin + parsed.pathname).slice(0, MAX_URL_LENGTH);
    } catch (error) {
      return '';
    }
  }

  function parameter(search, name) {
    try {
      var value = new URLSearchParams(search || '').get(name) || '';
      return String(value).trim().slice(0, MAX_PARAMETER_LENGTH);
    } catch (error) {
      return '';
    }
  }

  function emptyEnvelope() {
    var value = {
      version: 1,
      original_landing_url: '',
      original_external_referrer: ''
    };
    PARAMETER_NAMES.forEach(function (name) { value[name] = ''; });
    return value;
  }

  function validEnvelope(value) {
    if (!value || value.version !== 1) return false;
    if (typeof value.original_landing_url !== 'string') return false;
    if (typeof value.original_external_referrer !== 'string') return false;
    if (value.original_landing_url.length > MAX_URL_LENGTH) return false;
    if (value.original_external_referrer.length > MAX_URL_LENGTH) return false;
    return PARAMETER_NAMES.every(function (name) {
      return typeof value[name] === 'string' && value[name].length <= MAX_PARAMETER_LENGTH;
    });
  }

  function readEnvelope() {
    var raw = identityGet(ENVELOPE_KEY);
    if (!raw) return null;
    try {
      var value = JSON.parse(raw);
      if (!validEnvelope(value)) return null;
      identityMemory[ENVELOPE_KEY] = raw;
      return value;
    } catch (error) {
      return null;
    }
  }

  function captureFirstTouch() {
    var current = readEnvelope();
    if (current) return current;

    var value = initialFirstTouch;
    if (!value) {
      value = emptyEnvelope();
      value.original_landing_url = cleanUrl(window.location.href);
      value.original_external_referrer = externalReferrer(document.referrer || '');
      PARAMETER_NAMES.forEach(function (name) {
        value[name] = parameter(window.location.search, name);
      });
      initialFirstTouch = value;
    }
    identitySet(ENVELOPE_KEY, JSON.stringify(value));
    return value;
  }

  function secureUuid() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID().toLowerCase();
      }
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        var bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        bytes[6] = (bytes[6] & 15) | 64;
        bytes[8] = (bytes[8] & 63) | 128;
        var hex = Array.prototype.map.call(bytes, function (byte) {
          var value = byte.toString(16);
          return value.length === 1 ? '0' + value : value;
        }).join('');
        return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-');
      }
    } catch (error) {}
    return '';
  }

  function createWebsiteInquiryId() {
    if (resolveStorageNamespace() === null) return '';
    var existing = identityGet(INQUIRY_ID_KEY);
    if (ID_PATTERN.test(existing)) {
      identityMemory[INQUIRY_ID_KEY] = existing;
      return existing;
    }
    var uuid = secureUuid();
    var value = uuid ? 'wi-' + uuid : '';
    if (value) identitySet(INQUIRY_ID_KEY, value);
    return value;
  }

  function removeStorage(key) {
    var namespace = resolveStorageNamespace();
    if (namespace === null) return;
    try {
      window.sessionStorage.removeItem(namespace + key);
    } catch (error) {}
  }

  function deviceCategory() {
    var value = window.navigator && window.navigator.userAgent
      ? window.navigator.userAgent
      : '';
    return /Android|iPhone|iPad|iPod|Mobile/i.test(value) ? 'mobile' : 'desktop';
  }

  function diagnostic(stage, reference, result) {
    var envelope = readEnvelope() || captureFirstTouch();
    var entries = Array.isArray(window.LynxtourWhatsAppDiagnostics)
      ? window.LynxtourWhatsAppDiagnostics
      : [];
    entries.push({
      stage: stage,
      whatsapp_reference: reference || '',
      website_inquiry_id: createWebsiteInquiryId(),
      device_category: deviceCategory(),
      timestamp_utc: new Date().toISOString(),
      origin: window.location.origin,
      first_landing_page: envelope.original_landing_url || '',
      result: result || ''
    });
    if (entries.length > 30) entries.splice(0, entries.length - 30);
    window.LynxtourWhatsAppDiagnostics = entries;
    try {
      if (new URLSearchParams(window.location.search || '').get('lynxtour_wa_debug') === '1' &&
          window.console && typeof window.console.info === 'function') {
        window.console.info('[Lynxtour WhatsApp]', JSON.stringify(entries[entries.length - 1]));
      }
    } catch (error) {}
  }

  function randomReference() {
    var alphabet = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';
    try {
      if (!window.crypto || typeof window.crypto.getRandomValues !== 'function') return '';
      var bytes = new Uint8Array(10);
      window.crypto.getRandomValues(bytes);
      var value = '';
      for (var index = 0; index < bytes.length; index += 1) {
        value += alphabet.charAt(bytes[index] & 31);
      }
      return WHATSAPP_REFERENCE_PREFIX + value;
    } catch (error) {
      return '';
    }
  }

  function getWhatsAppReference() {
    if (resolveStorageNamespace() === null) return '';
    var existing = identityGet(WHATSAPP_REFERENCE_KEY);
    if (/^LX-[23456789A-HJ-NP-Z]{10}$/.test(existing)) {
      identityMemory[WHATSAPP_REFERENCE_KEY] = existing;
      return existing;
    }
    var value = randomReference();
    if (value) {
      identitySet(WHATSAPP_REFERENCE_KEY, value);
      diagnostic('generated', value, 'local');
    }
    return value;
  }

  function resolveWhatsAppReference(value) {
    if (!value || value !== getWhatsAppReference()) return null;
    return {
      reference: value,
      website_inquiry_id: createWebsiteInquiryId(),
      attribution: readEnvelope() || captureFirstTouch()
    };
  }

  function isWhatsAppUrl(value) {
    try {
      var parsed = new URL(value, window.location.origin);
      return parsed.protocol === 'whatsapp:' ||
        /^(api|web)\.whatsapp\.com$/i.test(parsed.hostname) ||
        /^(www\.)?wa\.me$/i.test(parsed.hostname);
    } catch (error) {
      return false;
    }
  }

  function runtimeContext() {
    var host = String(window.location.hostname || '').toLowerCase();
    var shopify = window.Shopify;
    if (PREVIEW_CONTEXT_CONFIRMED || new URLSearchParams(window.location.search || '').has('preview_theme_id') ||
      host === 'shopifypreview.com' || /\.shopifypreview\.com$/.test(host) ||
      !!(shopify && (shopify.designMode || shopify.inspectMode))) {
      PREVIEW_CONTEXT_CONFIRMED = true;
      return 'PREVIEW';
    }
    var role = shopify && shopify.theme && String(shopify.theme.role || '').toLowerCase();
    if (!role) return 'UNKNOWN';
    if (role === 'main') return 'MAIN';
    PREVIEW_CONTEXT_CONFIRMED = true;
    return 'PREVIEW';
  }

  function resolveStorageNamespace() {
    var context = runtimeContext();
    if (context === 'UNKNOWN') return null;
    var namespace = context === 'MAIN' ? '' : 'lynxtour_preview_';
    if (STORAGE_NAMESPACE !== namespace) {
      STORAGE_NAMESPACE = namespace;
      identityMemory = {};
      registryPendingMemory = null;
      registryRegisteredMemory = '';
      retriedPendingReference = '';
    }
    return namespace;
  }

  function registryConfig() {
    if (runtimeContext() !== 'MAIN') return null;
    var raw = window.LynxtourWhatsAppRegistryConfig;
    if (!raw || raw.enabled !== true || typeof raw.endpoint !== 'string') return null;
    try {
      var endpoint = new URL(raw.endpoint);
      if (endpoint.protocol !== 'https:' || endpoint.username || endpoint.password) return null;
      if (endpoint.search || endpoint.hash) return null;
      var requested = Number(raw.timeoutMs);
      var timeout = Number.isFinite(requested) && requested > 0
        ? Math.min(requested, MAX_REGISTRY_TIMEOUT_MS)
        : DEFAULT_REGISTRY_TIMEOUT_MS;
      return { endpoint: endpoint.toString(), timeoutMs: timeout };
    } catch (error) {
      return null;
    }
  }

  function registryPayload(reference) {
    var envelope = readEnvelope() || captureFirstTouch();
    return {
      whatsapp_reference: reference,
      website_inquiry_id: createWebsiteInquiryId(),
      contract_version: WHATSAPP_REGISTRY_CONTRACT,
      first_landing_page: envelope.original_landing_url || '',
      external_referrer: envelope.original_external_referrer || '',
      utm_source: envelope.utm_source || '',
      utm_medium: envelope.utm_medium || '',
      utm_campaign: envelope.utm_campaign || '',
      utm_term: envelope.utm_term || '',
      utm_content: envelope.utm_content || '',
      gclid: envelope.gclid || '',
      gbraid: envelope.gbraid || '',
      wbraid: envelope.wbraid || ''
    };
  }

  function registryRequestBody(payload) {
    var body = new URLSearchParams();
    Object.keys(payload).forEach(function (key) {
      body.set(key, payload[key] || '');
    });
    return body.toString();
  }

  function registryRequestMode() {
    return /\.myshopify\.com$/i.test(window.location.hostname || '') ? 'no-cors' : 'cors';
  }

  function isRegistryRegistered(reference) {
    return !!reference && (registryRegisteredMemory === reference || storageGet(WHATSAPP_REGISTRY_REGISTERED_KEY) === reference);
  }

  function markRegistryRegistered(reference) {
    if (!reference) return;
    registryRegisteredMemory = reference;
    registryPendingMemory = null;
    storageSet(WHATSAPP_REGISTRY_REGISTERED_KEY, reference);
    removeStorage(WHATSAPP_REGISTRY_PENDING_KEY);
  }

  function persistRegistryPending(reference) {
    if (!reference) return null;
    var pending = { version: 2, trigger: 'WHATSAPP_CLICK', clicked_at: new Date().toISOString(), reference: reference, payload: registryPayload(reference) };
    registryPendingMemory = pending;
    storageSet(WHATSAPP_REGISTRY_PENDING_KEY, JSON.stringify(pending));
    return pending;
  }

  function readRegistryPending() {
    var raw = storageGet(WHATSAPP_REGISTRY_PENDING_KEY);
    if (!raw && !registryPendingMemory) return null;
    try {
      var pending = registryPendingMemory || JSON.parse(raw);
      if (!pending || pending.version !== 2 || pending.trigger !== 'WHATSAPP_CLICK' ||
          !Number.isFinite(Date.parse(pending.clicked_at)) || pending.reference !== getWhatsAppReference() ||
          !pending.payload || pending.payload.whatsapp_reference !== pending.reference ||
          pending.payload.website_inquiry_id !== createWebsiteInquiryId()) return null;
      return pending;
    } catch (error) {
      return null;
    }
  }

  function completeRegistryRequest(operation, accepted, result) {
    if (registryRequests[operation.reference] !== operation || operation.settled) return;
    operation.settled = true;
    window.clearTimeout(operation.timer);
    delete registryRequests[operation.reference];
    if (accepted && operation.namespace !== resolveStorageNamespace()) {
      accepted = false;
      result = 'context_changed';
    }
    if (accepted) {
      markRegistryRegistered(operation.reference);
      diagnostic('server_received', operation.reference, result);
    }
    diagnostic(accepted ? 'registry_success' : 'registry_failed', operation.reference, result);
    operation.callbacks.forEach(function (callback) { callback(accepted); });
    operation.callbacks = [];
  }

  function isDurableRegistryAck(payload) {
    return !!payload && payload.code === 'SUCCESS' &&
      !!payload.data && typeof payload.data === 'object' &&
      !Array.isArray(payload.data) && payload.data.recorded === true;
  }

  function registerWhatsAppReference(reference, config, complete) {
    var callback = typeof complete === 'function' ? complete : function () {};
    if (!reference || !config || typeof window.fetch !== 'function') {
      callback(false);
      return;
    }
    if (isRegistryRegistered(reference)) {
      callback(true);
      return;
    }
    if (registryRequests[reference]) {
      registryRequests[reference].callbacks.push(callback);
      return;
    }
    var pending = readRegistryPending();
    if (!pending || pending.reference !== reference) { callback(false); return; }
    var operation = { reference: reference, namespace: resolveStorageNamespace(), callbacks: [callback], timer: null, settled: false };
    registryRequests[reference] = operation;
    operation.timer = window.setTimeout(function () {
      completeRegistryRequest(operation, false, 'timeout');
    }, config.timeoutMs);
    diagnostic('registration_attempted', reference, 'pending');
    try {
      var requestMode = registryRequestMode();
      var request = window.fetch(config.endpoint, {
        method: 'POST',
        mode: requestMode,
        credentials: 'omit',
        redirect: 'error',
        keepalive: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: registryRequestBody(pending.payload)
      });
      diagnostic('request_sent', reference, 'fetch');
      request.then(function (response) {
        if (registryRequests[reference] !== operation || operation.settled) return;
        if (response && response.type === 'opaque') {
          completeRegistryRequest(operation, false, 'opaque_dispatch');
          return;
        }
        if (!response || response.ok !== true) {
          completeRegistryRequest(operation, false, 'http_' + String(response && response.status || 0));
          return;
        }
        if (typeof response.json !== 'function') {
          completeRegistryRequest(operation, false, 'invalid_ack');
          return;
        }
        return response.json().then(function (payload) {
          var accepted = isDurableRegistryAck(payload);
          completeRegistryRequest(operation, accepted, accepted ? String(response.status) : 'invalid_ack');
        });
      }).catch(function (error) {
        completeRegistryRequest(operation, false, error && error.name ? error.name : 'network_error');
      });
    } catch (error) {
      completeRegistryRequest(operation, false, error && error.name ? error.name : 'request_error');
    }
  }

  function retryPendingWhatsAppRegistration() {
    var config = registryConfig();
    if (!config) return;
    var pending = readRegistryPending();
    if (!pending || isRegistryRegistered(pending.reference) || retriedPendingReference === pending.reference) return;
    retriedPendingReference = pending.reference;
    registerWhatsAppReference(pending.reference, config, function () {});
  }

  function releaseWhatsAppNavigation(operation) {
    if (whatsappNavigation !== operation) return;
    window.clearTimeout(operation.waitTimer);
    window.clearTimeout(operation.recoveryTimer);
    if (typeof operation.link.removeAttribute === 'function') {
      operation.link.removeAttribute('data-lynxtour-registry-navigation');
    }
    whatsappNavigation = null;
  }

  function beginWhatsAppNavigation(link, attribute) {
    var operation = { link: link, state: 'WAITING', hidden: false, waitTimer: null, recoveryTimer: null };
    whatsappNavigation = operation;
    link.setAttribute(attribute, 'pending');
    return operation;
  }

  function finishNativeWhatsAppHandoff(operation) {
    operation.state = 'HANDOFF';
    operation.hidden = document.visibilityState === 'hidden';
    operation.recoveryTimer = window.setTimeout(function () {
      if (document.visibilityState !== 'hidden') releaseWhatsAppNavigation(operation);
    }, WHATSAPP_HANDOFF_RECOVERY_MS);
  }

  function recoverWhatsAppNavigation(event) {
    var operation = whatsappNavigation;
    if (!operation) return;
    if (event && event.type === 'pageshow' && event.persisted) {
      releaseWhatsAppNavigation(operation);
    } else if (operation.state === 'HANDOFF') {
      if (document.visibilityState === 'hidden') operation.hidden = true;
      if (document.visibilityState === 'visible' && operation.hidden) releaseWhatsAppNavigation(operation);
    }
  }

  function decorateWhatsAppLink(link) {
    if (!link || !isWhatsAppUrl(link.href)) return;
    var reference = getWhatsAppReference();
    if (!reference) return;
    try {
      var url = new URL(link.href, window.location.origin);
      var text = url.searchParams.get('text') || "Hi, I'd like help planning a private Yunnan trip.";
      if (text.indexOf('Ref: ' + reference) === -1) {
        text = text.replace(/\s+$/, '') + ' Ref: ' + reference;
      }
      url.searchParams.set('text', text);
      link.href = url.toString();
      link.setAttribute('data-lynxtour-whatsapp-reference', reference);
    } catch (error) {}
  }

  function decorateWhatsAppLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var links = scope.querySelectorAll ? scope.querySelectorAll('a[href]') : [];
    Array.prototype.forEach.call(links, decorateWhatsAppLink);
  }

  function trackWhatsAppHandoff(event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!link || !isWhatsAppUrl(link.href) || event.defaultPrevented || event.button > 0 || event.isTrusted === false) return;
    if (whatsappNavigation) {
      event.preventDefault();
      return;
    }
    decorateWhatsAppLink(link);
    var reference = link.getAttribute('data-lynxtour-whatsapp-reference') || '';
    var payload = {
      event: 'whatsapp_attribution_handoff',
      inquiry_reference: reference,
      whatsapp_reference: reference,
      website_inquiry_id: createWebsiteInquiryId(),
      event_source: 'lynxtour_theme'
    };
    if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(payload);
    diagnostic('whatsapp_handoff', reference, 'native_activation');
    var operation = beginWhatsAppNavigation(link, 'data-lynxtour-registry-navigation');
    finishNativeWhatsAppHandoff(operation);
    var config = registryConfig();
    if (config && !isRegistryRegistered(reference)) {
      persistRegistryPending(reference);
      registerWhatsAppReference(reference, config, function () {});
    }
  }

  var api = {
    captureFirstTouch: captureFirstTouch,
    getFirstTouch: function () { return readEnvelope() || captureFirstTouch(); },
    createWebsiteInquiryId: createWebsiteInquiryId,
    isWebsiteInquiryId: function (value) { return ID_PATTERN.test(value || ''); },
    getWhatsAppReference: getWhatsAppReference,
    resolveWhatsAppReference: resolveWhatsAppReference,
    decorateWhatsAppLinks: decorateWhatsAppLinks
  };

  window.LynxtourAttribution = Object.freeze(api);
  captureFirstTouch();
  if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', function () {
      captureFirstTouch();
      decorateWhatsAppLinks(document);
      retryPendingWhatsAppRegistration();
    });
    document.addEventListener('visibilitychange', function (event) {
      recoverWhatsAppNavigation(event);
      if (document.visibilityState === 'visible') retryPendingWhatsAppRegistration();
    });
    if (typeof window.addEventListener === 'function') {
      window.addEventListener('pageshow', function (event) {
        recoverWhatsAppNavigation(event);
        retryPendingWhatsAppRegistration();
      });
    }
    document.addEventListener('click', trackWhatsAppHandoff, true);
  }
})(window, document);
